export default "__VITE_ASSET__DFypmTZ7__"